import React, { useState, useEffect } from 'react';
import TextBlock from './TextBlock';
import TextBlockInfo from './TextBlockAbout';

export default function ContentBlock({ pageData }) {
  const [place, setPlace] = useState('');
  const apiToken =
    'pk.eyJ1IjoibG91aXNlcGljb3QiLCJhIjoiY2t2YzNwbW1oMGhoZjJ3bzhpaWZxazJ3cSJ9.jcupwDKk_QBW9WMbQhtCcA';

  useEffect(() => {
    let isMounted = true;
    // get data from GitHub api
    if (pageData.lieux) {
      fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${pageData.lieux.lng},${pageData.lieux.lat}.json?types=place&access_token=${apiToken}`
      )
        .then((response) => response.json()) // parse JSON from request
        .then((resultData) => {
          if (isMounted) setPlace(resultData.features[0].text);
        });
    }

    return () => {
      isMounted = false;
    };
    // set data for the number of stars
  }, []);

  const checkPage = () => {
    if (pageData.realisation) {
      return pageData.realisation;
    }
    if (pageData.etude) {
      return pageData.etude;
    }
    if (pageData.actu) {
      return pageData.actu;
    }
    return pageData;
  };

  return (
    <div>
      {!checkPage().queryPage ? (
        <TextBlock pageData={checkPage()} place={place} />
      ) : (
        <TextBlockInfo data={pageData.queryPage.nodes[0]}  />
      )}
    </div>
  );
}
